import { render } from "./Sales_Management.vue?vue&type=template&id=095d91ba"
import script from "./Sales_Management.vue?vue&type=script&lang=js"
export * from "./Sales_Management.vue?vue&type=script&lang=js"

import "./Sales_Management.vue?vue&type=style&index=0&id=095d91ba&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__